import React, { useState, useEffect, useCallback } from 'react';
import Select, { SingleValue, InputActionMeta } from 'react-select';
import ApiClient from "../../utilities/http";
import { Endpoints } from "../../utilities/endpoints";
import debounce from 'lodash.debounce';
import { Form } from "react-bootstrap";
import { Option } from "../../models/types";
import { useTranslation } from 'react-i18next';
import AsyncSelect from "react-select/async";
import { ILocation } from '../../models/ILocation';
import { ICard } from '../../models/ICard';

// Define the shape of the API response
interface ApiResponse {
    id: string | number;
    name: string;
}

interface Props {
    onSelect: Function;
    value?: SingleValue<Option>; // Accept value from the parent
    extraFilter?: { type: string, value: ILocation };//add other possible types for value later
    label: string;
    name: string;
    controller: string;
    id?: string;
    wrap?: boolean;
}

interface ReqParamsType {
    search_key: string;
    limit: number;
    location?: string;
    // card?: ICard;
}

const SearchableSelect: React.FC<Props> = ({ onSelect, ...props }) => {
    const { i18n } = useTranslation();
    // @ts-ignore
    const t = (txt: string) => i18n.t(txt);
    const [selectedValue, setSelectedValue] = useState<SingleValue<Option>>(null);

    const loadOptions = debounce(
        (inputValue: string, callback: (opts: Option[]) => void) => {
            let reqParams: ReqParamsType = {
                search_key: inputValue, // Query parameter for filtering
                limit: 10,         // Limit the number of results
            }
            if (props.extraFilter !== undefined) {
                switch (props.extraFilter.type) {
                    case 'ILocation':
                        reqParams.location = props.extraFilter.value.id;
                        break;
                }
            }
            ApiClient.get<ApiResponse[]>(`${Endpoints.SEARCH}/${props.controller}`, {
                params: reqParams
            }).then(res => {
                const opts = res.data.map(item => ({ value: item.id, label: item.name }));
                callback(opts);
            });
        },
        300
    );

    // Handle selection change
    const handleChange = (selected: SingleValue<Option>): void => {
        console.log('Selected option:', selected);
        setSelectedValue(selected);
        onSelect(selected);
    };

    useEffect(function () {
        if (props.value) setSelectedValue(props.value);
    }, [props.value]);

    const content = (
        <AsyncSelect
            styles={{
                control: (base) => ({ ...base, boxShadow: 'none', width: '100%', height: '42px' }),
            }}
            cacheOptions
            defaultOptions
            loadOptions={loadOptions}
            onChange={handleChange}
            value={selectedValue}
            isClearable
            placeholder={t('Search and select...')}
            noOptionsMessage={() => t('No options found')}
        />
    );
    const wrap = props.wrap !== false;
    return wrap ? (
        <Form.Group controlId={props.id || props.name}>
            <Form.Label>{t(props.label)}</Form.Label>
            {content}
        </Form.Group>
    ) : (
        content
    );
};

export default SearchableSelect;
